import api from "./api"

export const getFormEntriesByFormName = async (formName, filters) => {
    const params = { formName }
    if (filters && Object.keys(filters).length > 0) {
        params["filters"] = JSON.stringify(filters)
    }
    const res = await api.get(`/form-entries`, { params });
    return res?.data;
}